import { wixVsWordpresss } from "./Markdown/Wix_vs_wordpress"

export const BlogsConfig = {

    "title": "TurboSteed Blog",
    "subTitle": "Your go-to resource for insights and tips on hosting",

    "blogList": [
        {
            "blogImage": "",
            "blogTitle": "Quick & easy static website hosting",
            "blogDesc": "A tutorial for anyone who wants an online presence",
            "blogUrl": "/blogs/host-static-websites",
            "blogType": "HowTo"
        },
        {
            "blogImage": "",
            "blogTitle": "Host Single Page Applications",
            "blogDesc": "A tutorial to host Single page React applications",
            "blogUrl": "/blogs/host-react-apps",
            "blogType": "HowTo"
        },
        {
            "blogImage": "",
            "blogTitle": "Quick Contact Forms",
            "blogDesc": "Use Contact Forms widget or API to engage with your users",
            "blogUrl": "/blogs/contact-forms",
            "blogType": "HowTo"
        },
        {
            "blogImage": "",
            "blogTitle": "Wix vs WordPress Platforms: Which One Should You Choose in 2025?",
            "blogDesc": "Trying to decide between Wix and WordPress platforms, read this",
            "blogUrl": "/blogs/wix-vs-wordpress",
            "blogType": "HowTo"
        },
        {
            "blogImage": "",
            "blogTitle": "TurboSteed for AI Agents: Why Agent-Operable Hosting Matters",
            "blogDesc": "How AI coding agents like Claude Code are changing web development and why TurboSteed is built for this new reality",
            "blogUrl": "/blogs/turbosteed-for-ai-agents",
            "blogType": "Guide"
        },
    ]
}

export const BlogList = {
    "host-static-websites" : {
        "blogHeader": {
            "blogTitle": "Quick and easy static website hosting",
            "blogSubTitle": "A tutorial for anyone who wants an online presence",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Nov 2024",
            "blogCategory": "HowTo",
            "blogType": ""
        },
        "blogSeo": {
            "mainSeo": {
                "title": "Quick & Easy Static Website Hosting | TurboSteed Tutorial",
                "description": "Step-by-step tutorial to host your static website on TurboSteed. Upload a zip file and go live in minutes - no coding required.",
                "canonicalUrl": "https://turbosteed.com/blogs/host-static-websites",
                "keywords": "static website hosting, free web hosting, upload website, TurboSteed tutorial",
                "ogType": "article",
                "ogTitle": "Host a Static Website in Minutes",
                "ogDescription": "Learn how to get your website online with TurboSteed's simple upload process.",
                "twitterCard": "summary_large_image",
                "robots": "index, follow"
            },
            "schemaMarkup": {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "Quick and easy static website hosting",
                "datePublished": "2024-11-01",
                "author": { "@type": "Person", "name": "Vivek Joshi" },
                "publisher": {
                    "@type": "Organization",
                    "name": "TurboSteed",
                    "logo": { "@type": "ImageObject", "url": "https://turbosteed.com/turbo-navbar-logo.png" }
                }
            }
        },
        "blogBody": [
            { 
                "tagType": "p", 
                "tagContent": "The World Wide Web is one of the most accessible platforms to connect with the world. Whether you're a professional, a student, or someone with a creative passion, the web offers limitless opportunities to share your story, ideas, or portfolio."
            },
            { 
                "tagType": "p", 
                "tagContent": "Yet for many, having a permanent online presence through a personal website remains a dream. Why? Common obstacles include complexity, lack of technical know-how, financial costs, limited time, and sheer effort."
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 1: Create a TurboSteed account"
        
            },
            {
                "tagType": "p",
                "tagContent": "To get started, visit <a href='https://www.turbosteed.com'>turbosteed.com</a> and create your account. Simply click the <a href='https://dashboard.turbosteed.com'>Login</a> button and sign in using your Google account. Once logged in, you’ll be directed to your dashboard, the central hub for managing your website."
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 2: Choose a Site name"
            },
            {
                "tagType": "p",
                "tagContent": "Your site name (technically referred to as a subdomain) is how your website will be identified on TurboSteed. Choose a name that reflects your website's purpose or personal branding." + " " +

                                                        "For example, if your name is John Doe, you might name your site ‘john’, resulting in a URL like ‘john.turbosteed.com’. Feel free to get creative—the name is entirely up to you!"
            
            },
            {
                "tagType": "p",
                "tagContent": "In this tutorial, we choose the name ‘Ethan Thompson’ as an example who is building a developer portfolio. Hence, we have named this site ‘ethan-thompson', resulting in the address ‘ethan-thompson.turbosteed.com’. After selecting your site name, click the Update button to save your choice."
            },
            {
                "tagType": "image",
                "tagContent": "darksitename.svg",
                "altText": "Instructions to create a site name on TurboSteed dashboard"
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "p",
                "tagContent": "You can purchase a domain name and link it with your turbosteed account to make your website all professional. Please contact <a href='mailto:support@turbosteed.com'>support</a> to assist you in doing so."
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 3: Upload your static website"
            },
            {
                "tagType": "p",
                "tagContent": "You can either create a static website from scratch or choose from thousands of popular templates available online. (Some references include <a href='https://designmodo.com/website-templates/'>Designmodo</a>, <a href='https://themeforest.net/search/static?compatible_with=Bootstrap&sort=price-asc#content'>ThemeForest</a>, and similar platforms.) Many templates are free, while more advanced options are available for purchase."

                                                        + " Once you’ve built your website or customized a template, compress the folder containing your website’s code into a ZIP file. Ensure the folder includes a file named index.html in the root directory, as this serves as the entry point for your site."

                                                        + " For simplicity, you can <a href='https://github.com/turbosteed/static-site/archive/refs/heads/main.zip'>download</a> a static website on our GitHub page. (Don’t worry—you can always update the content later with your own)."
            },
            {
                "tagType": "p",
                "tagContent": "On your TurboSteed dashboard, navigate to the page where you entered your site name. Below the screenshot preview, click the Choose File button and upload your .zip file."
            },
            {
                "tagType": "image",
                "tagContent": "darksiteupload.svg",
                "altText": "Instructions to upload a static website on TurboSteed"
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "p",
                "tagContent": "Once the upload is complete, your website will go live instantly. The screenshot will update to show a preview of your new website. For this demo, the webpage will display the sample content we provided."
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "image",
                "tagContent": "darksitedemo.png",
                "altText": "A live demo of the website code uploaded on TurboSteed"
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 4: Share your website"
            },
            {
                "tagType": "p",
                "tagContent": "Congratulations! Your website is now live and accessible at ‘your-site-name.turbosteed.com’. Share your link with friends, colleagues, or anyone you want to impress."

                                                                + " With TurboSteed, creating an online presence has never been easier. Whether you’re showcasing a portfolio, starting a blog, or building something unique, we’re here to help you make it happen."
                                                        
            },
            {
                "tagType": "p",
                "tagContent": "<a href='https://dashboard.turbosteed.com'>Start hosting</a> today and unlock your web potential!"
            }
        ]
    }, 

    "host-react-apps" : {
        "blogHeader": {
            "blogTitle": "Host Single Page Applications (SPA)",
            "blogSubTitle": "A tutorial to host single-page React applications",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Dec 2024",
            "blogCategory": "HowTo",
            "blogType": ""
        },
        "blogSeo": {
            "mainSeo": {
                "title": "Host Single Page React Applications | TurboSteed Tutorial",
                "description": "Learn how to build a React app and deploy it as a static site on TurboSteed. Complete tutorial with Pomodoro timer example.",
                "canonicalUrl": "https://turbosteed.com/blogs/host-react-apps",
                "keywords": "host React app, single page application hosting, SPA hosting, React deployment",
                "ogType": "article",
                "ogTitle": "Deploy React Apps on TurboSteed",
                "ogDescription": "Build and host your React single-page applications with our step-by-step guide.",
                "twitterCard": "summary_large_image",
                "robots": "index, follow"
            },
            "schemaMarkup": {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "Host Single Page Applications (SPA)",
                "datePublished": "2024-12-08",
                "author": { "@type": "Person", "name": "Vivek Joshi" },
                "publisher": {
                    "@type": "Organization",
                    "name": "TurboSteed",
                    "logo": { "@type": "ImageObject", "url": "https://turbosteed.com/turbo-navbar-logo.png" }
                }
            }
        },
        "blogBody": [
            { 
                "tagType": "p", 
                "tagContent": "In the world of web development, you may have come across the terms single-page applications (SPAs) and static websites. Understanding the difference between the two is key when deciding how to develop and deploy your web projects."
            },
            { 
                "tagType": "p", 
                "tagContent": "A static website consists of fixed content, usually HTML, CSS, and JavaScript files, that are served to users exactly as they are. Each time a user loads a page, the browser requests the server for that content, and the server responds with the same files. This makes static websites fast, simple, and perfect for sites with minimal interactivity, such as portfolios or blogs."
            },
            { 
                "tagType": "p", 
                "tagContent": "On the other hand, a single-page application (SPA), like a <a href='https://react.dev'>React</a> app, is a type of web application that dynamically updates content without requiring a full page reload. SPAs load a single HTML page and then update only the relevant parts of the page as users interact with it. React, Vue, and Angular are popular frameworks for building SPAs. Unlike static websites, SPAs allow for rich user interactivity, often making them feel more like desktop applications."
            },
            { 
                "tagType": "p", 
                "tagContent": "Now, let's dive into how to build a simple React app (a Pomodoro Timer) and host it on a static website hosting platform."
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Introduction to the ReactJS Framework"
        
            },
            {
                "tagType": "p",
                "tagContent": "ReactJS is a powerful JavaScript library used for building user interfaces, especially for single-page applications. It allows developers to create reusable UI components, making development faster and more efficient. React uses a virtual DOM (Document Object Model), which ensures updates to the UI are fast and minimal. It’s highly popular because of its simplicity, flexibility, and performance."
            },
            {
                "tagType": "p",
                "tagContent": "One of React's key features is its component-based architecture. A React app consists of small, independent components that handle their own logic and rendering. These components are combined to form a complete UI."
            },
            {
                "tagType": "p",
                "tagContent": "In this tutorial, we’ll build a simple Pomodoro timer app using React. The Pomodoro Technique is a time management method that involves working in 25-minute intervals followed by short breaks, with longer breaks after several sessions."
            },
            {
                "tagType": "newLine",
                "tagContent": ""
            },
            {
                "tagType": "subTitle",
                "tagContent": "Creating a Pomodoro Timer App in React and Testing It on Localhost"
            },
            {
                "tagType": "p",
                "tagContent": "Now, let’s start by creating our Pomodoro timer application. To do so, you’ll need to have Node.js and npm (Node Package Manager) installed on your machine."
            
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 1: Set Up Your React App"
            },
            {
                "tagType": "p",
                "tagContent": "First, open your terminal and create a new React app using create-react-app. This is a tool that sets up everything you need to run a React application."
            },
            {
                "tagType": "pre",
                
                "tagContent": `
npx create-react-app pomodoro-timer
cd pomodoro-timer`
            },
            {
                "tagType": "p",
                "tagContent": "This will create a new directory named pomodoro-timer and set up the basic files and dependencies for a React application."
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 2: Create a Pomodoro Timer Component"
            },
            {
                "tagType": "p",
                "tagContent": "Inside your newly created React app, open the src folder and modify the App.js file to include the Pomodoro timer logic."
            },
            {
                "tagType": "p",
                "tagContent": "Replace the default content of App.js with the following code:"
            },
            {
                "tagType": "pre",
                
                "tagContent": `
import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [timeLeft, setTimeLeft] = useState(1500); // Time in seconds (1500s = 25 minutes)
  const [isActive, setIsActive] = useState(false);

  // Timer functionality
  useEffect(() => {
    let interval = null;

    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (!isActive && timeLeft === 0) {
      setIsActive(false);
      alert("Pomodoro session complete! Take a break.");
    }

    return () => clearInterval(interval);
  }, [isActive, timeLeft]);

  // Start/stop the timer
  const toggleTimer = () => {
    setIsActive(!isActive);
  };

  // Reset the timer
  const resetTimer = () => {
    setIsActive(false);
    setTimeLeft(1500);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return \`\${String(minutes).padStart(2, '0')}:\${String(seconds).padStart(2, '0')}\`;
  };

  return (
    <div className="App">
      <h1>Pomodoro Timer</h1>
      <div className="timer">
        <p>{formatTime(timeLeft)}</p>
        <button onClick={toggleTimer}>
          {isActive ? 'Pause' : 'Start'}
        </button>
        <button onClick={resetTimer}>Reset</button>
      </div>
    </div>
  );
}

export default App;

                `
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 3: Style your timer"
            },
            {
                "tagType": "p",
                "tagContent": "You can style the timer by modifying the App.css file. For simplicity, here's some basic styling:"
            },
            {
                "tagType": "pre",
                "tagContent": `
.App {
  text-align: center;
  font-family: 'Arial', sans-serif;
  margin-top: 50px;
}

.timer {
  display: inline-block;
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 8px;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  margin: 5px;
  border: none;
  border-radius: 5px;
}

button:hover {
  background-color: #ddd;
}
                ` 
            
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Step 4: Run your app locally"
            },
            {
                "tagType": "p",
                "tagContent": "Now, to see your Pomodoro timer in action, run the app locally:"
            },
            {
                "tagType": "pre",
                "tagContent": `npm start`
            },
            {
                "tagType": "p",
                "tagContent": "Your default browser should open with your React app running at http://localhost:3000. You can now test the timer functionality: start, pause, and reset the Pomodoro timer."
            },
            {
                "tagType": "image",
                "tagContent": "pomodoro.svg",
                "altText": "Instructions to create a site name on TurboSteed dashboard"
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Preparing to uploaad your website"
            },
            {
                "tagType": "p",
                "tagContent": "The above test was in a development environment. This makes the ReactJS project size larger to enable debugging. This is however not required in production."
            },
            {
                "tagType": "p",
                "tagContent": "Follow the below commands to create a production build of your project:"
            },
            {
                "tagType": "pre",
                "tagContent": `
npm run build
serve -s build`
            },
            {
                "tagType": "p",
                "tagContent": "You can now test your production ready React app running at http://localhost:3000."
            },
            
            {
                "tagType": "p",
                "tagContent": "The SPA content is now ready for upload. You can zip the contents of the build directory and upload the same by following instructions at <a href='http://localhost:3000/blogs/host-static-websites'>Hosting Static Websites</a>."
            },
            {
                "tagType": "newLine",
                "tagContent": "",
            },
            {
                "tagType": "subTitle",
                "tagContent": "Conclusion"
            },
            {
                "tagType": "p",
                "tagContent": `In this tutorial, we walked through the process of building a simple Pomodoro timer app using ReactJS, a popular framework for developing dynamic single-page applications. We also explored how such an app differs from a static website, and discussed how to deploy it on your static hosting platform. React’s component-based structure makes it easy to scale and manage applications, and hosting them on static platforms allows for a fast, reliable user experience.

Now that you know how to build and host a React app, you can easily extend this knowledge to create more complex applications. Happy coding!`

                                    
            },
            {
                "tagType": "p",
                "tagContent": "<a href='https://dashboard.turbosteed.com'>Start hosting</a> today and unlock your web potential!"
            }

        ]
    },
    "contact-forms" : {

        "blogHeader": {
            "blogTitle": "Quick Contact Forms",
            "blogSubTitle": "Use Contact Forms widget or API to engage with your users",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Dec 2024",
            "blogCategory": "HowTo",
            "blogType": "innerHTML",
            //"markdownPage": "Contact_form.md"

        },
        "blogSeo": {
            "mainSeo": {
                "title": "Add Contact Forms to Your Website | TurboSteed Tutorial",
                "description": "Learn how to add contact forms to your static website using TurboSteed's Contact Form API or pre-built widget. No backend required.",
                "canonicalUrl": "https://turbosteed.com/blogs/contact-forms",
                "keywords": "contact form API, website contact form, static site contact form, TurboSteed widget",
                "ogType": "article",
                "ogTitle": "Quick Contact Forms for Static Websites",
                "ogDescription": "Add contact forms to your website without any server infrastructure using TurboSteed.",
                "twitterCard": "summary_large_image",
                "robots": "index, follow"
            },
            "schemaMarkup": {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "Quick Contact Forms",
                "datePublished": "2024-12-26",
                "author": { "@type": "Person", "name": "Vivek Joshi" },
                "publisher": {
                    "@type": "Organization",
                    "name": "TurboSteed",
                    "logo": { "@type": "ImageObject", "url": "https://turbosteed.com/turbo-navbar-logo.png" }
                }
            }
        },
        "blogBody": {
            "type": "document",
            "children": [
            {
                "type": "paragraph",
                "children": [
                    {
                    "type": "text",
                    "value": "At " 
                    },
                    {
                    "type": "link",
                    "text": "TurboSteed",
                    "url": "https://turbosteed.com"
                    },
                    {
                    "type": "text",
                    "value": ", we’re all about simplifying static website hosting while packing in powerful features to supercharge your web presence. One of our most exciting offerings is the Contact Form API, a seamless solution for integrating contact forms into your website with minimal effort. This feature does not require any server or database infrastructure on your part."
                    }
                ]
            },
            {
                "type": "paragraph",
                "children": [
                    {
                    "type": "text",
                    "value": "Let’s dive into how this feature works and why it’s an essential tool for modern web hosting."
                    }
                ]
            },
            {
                "type": "heading",
                "level": 4,
                "children": [
                    {
                    "type": "text",
                    "value": "Why Contact Forms Are Essential"
                    }
                ]
            },
            {
                "type": "paragraph",
                "children": [
                    {
                    "type": "text",
                    "value": "A contact form is more than just a way for visitors to reach out; it’s a cornerstone of effective communication and lead generation for any website. However, implementing and maintaining a contact form on a static website can be a technical challenge. That’s where our Contact Form API and Pre-built Contact Form Widget come into play, offering simplicity and flexibility for developers and non-technical users alike."
                    }
                ]
            },
            {
                "type": "paragraph",
                "children": [
                    {
                    "type": "text",
                    "value": "With our Contact Form API, you can:"
                    }
                ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Build custom Contact Form UI with TurboSteed API."
                    }
                ]
                },
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Stay secure with API token-based authentication."
                    }
                ]
                }
            ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Monitor and manage submissions effortlessly through TurboSteed dashboard."
                    }
                ]
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "With our Contact Form Widget, you can:"
                }
            ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Use pre-built Contact Form UI for faster integration and without any development (including all of the above benifits)."
                    }
                ]
                },
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Allow your site visitors to submit the contact form using the widget."
                    }
                ]
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Here’s how it works:"
                }
            ]
            },
            {
            "type": "heading",
            "level": 4,
            "children": [
                {
                "type": "text",
                "value": "1. For Developers: Using the Contact Form API"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "When you sign up for TurboSteed, you receive a unique Account ID and an API Token. These credentials are specifically built for Contact Form API where your website is publicly exposed. Here’s a quick walkthrough:"
                }
            ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Implementation: You can design your own contact form UI and configure it to send form submissions directly to our API."
                    }
                ]
                }
            ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Authentication: Use your Account ID and API Token in the headers to authenticate requests, ensuring secure communication."
                    }
                ]
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "The API endpoint is:"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "codeBlock",
                "value": "https://api-us.turbosteed.com/{accountID}/contactForms",
                "language": ""
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "This API uses a HTTP Basic authentication scheme. Please see the implementation example below:"
                }
            ]
            },
            {
            "type": "heading",
            "level": 5,
            "children": [
                {
                "type": "text",
                "value": "Example"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "codeBlock",
                "value": "const submitForm = async (formData) => {\n  try {\n    const response = await fetch('https://api-us.turbosteed.com/' + YOUR_ACCOUNT_ID + '/contactForms', {\n      method: 'POST',\n      headers: {\n        'Content-Type': 'application/json',\n        'X-TSA': btoa(acct + ':' + YOUR_API_TOKEN)  // This is the header under which the token is sent.\n      },\n      body: JSON.stringify({\n        formData: {\n          formName: name,        // The input name from the contact form.\n          formEmail: email,      // The input email from the contact form.\n          formMessage: message   // The input message from the contact form.\n        }\n      })\n    });\n\n    if (!response.ok) {\n      throw new Error('Failed to submit form');\n    }\n\n    console.log('Form submitted successfully:', await response.json());\n  } catch (error) {\n    console.error('Error submitting form:', error);\n  }\n};",
                "language": ""
                }
            ]
            },
            {
            "type": "heading",
            "level": 4,
            "children": [
                {
                "type": "text",
                "value": "2. For Non-Developers: Using the React Widget"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Not everyone has the time or expertise to build a custom UI, and that’s okay! Turbosteed offers a React-based widget that can be embedded on your website with just a few lines of code."
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Why Use the Widget?"
                }
            ]
            },
            {
            "type": "unorderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Quick Setup: Simply copy and paste the widget code into your HTML."
                    }
                ]
                },
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Quick Integration: The widget comes preconfigured to communicate with the Contact Form API. All you need to do is provide your authentication details."
                    }
                ]
                }
            ]
            },
            { 
                "type": "paragraph",
                "children": [
                  { 
                    "type": "text",
                    "value": "The hosted Contact Form widget looks like the below image:"
                  }
                ]
              },  
              {     
                "type": "paragraph",
                "children": [
                  {
                    "type": "image",
                    "text": "an example of a hosted contact form widget",
                    "url": "/contact-form-widget.png"
                  }
                ]   
              },    
          
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "To integrate the widget, you will have to do the following:"
                }
            ]
            },
            {
            "type": "heading",
            "level": 5,
            "children": [
                {
                "type": "text",
                "value": "Step 2: Changes to your HTML code"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Copy the following code in your static assets folder. (This is the folder where you will typically have your css files, images and so on)."
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "codeBlock",
                "value": "(function() {\n\n  var script = document.createElement('script');\n  script.type = 'text/javascript';\n\n  script.addEventListener('load', function(event) {\n\n    //\n    // OPTION CONFIGURATION:\n    // Specify the position of the contact form widget.\n    // By default, the widget will be placed in the bottom right corner of the page.\n    //\n    var widget = document.createElement('div');\n    widget.style.position = 'fixed';\n    widget.style.bottom = '20px';\n    widget.style.right = '20px';\n    widget.style.zIndex = '9999';\n    \n    //\n    // OPTIONAL STYLING:\n    // 'contact-form' is the element name under which the widget will be displayed.\n    // It has a button to show/hide the contact form. You can configure the text and\n    // style of the button here. (This button is similar to the window close button\n    // on your computer).\n    //\n    const buttonColor = 'white';             // The background color of the close button.\n    const buttonText = 'black';              // The text color of the close button.\n    const widgetButtonText = 'Contact Us';   // This is the name of the button  when\n                                             // the widget is no longer visible and\n                                             // the user has to click this button to\n                                             // open the contact form.\n\n    const widgetCloseText = 'x';             // This represents the close icon 'x'.\n          \n    widget.innerHTML = `\n      <div id=\"contact-form\">\n        <button id=\"widget-button\" style=\"border: none; border-radius: 2px; color: ${buttonText}; background-color: ${buttonColor}\" onClick=\"(function(event){\n          var widget = getElementById('contact-form-container');\n          if (widget.style.display == 'none') {\n            widget.style.display = 'block';\n            event.target.innerHTML = '${widgetCloseText}';\n          }\n          else {\n            widget.style.display = 'none';\n            event.target.innerHTML = '${widgetButtonText}';\n          }\n        })(event)\">\n        ${widgetCloseText}\n        </button>\n        <div id=\"contact-form-container\"></div>\n      </div>\n    `;\n\n    document.body.appendChild(widget);\n\n    //\n    // ACTION REQUIRED:\n    // Configure the styling and API details for your widget.\n    // 1. The background color for your widget.  (Optional action).\n    // 2. The font color for your widget.        (Optional action).\n    // 3. The button color for your widget.      (Optional action).\n    // 4. The publicly visible TurboSteed account identifier.  (Mandatory action).\n    // 5. The publicly visible TurboSteed API token.           (Mandatory action).\n    //\n    window.ContactFormWidget.renderWidget('contact-form-container', {\n        backgroundColor: '#f0f0f2',\n        fontColor: 'black',\n        buttonColor: '#1FA868',\n        apiAcct: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',\n        apiToken: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'\n    });\n  });\n\n  //\n  // This is the address of the contact form widget on TurboSteed. Do not\n  // change this.\n  //\n  script.src = 'https://turbosteed.com/contact-widget.js';\n\n  //    \n  // The widget in this example will be appended as the last HTML element of the page.  \n  //    \n  document.head.appendChild(script);\n})();",
                "language": ""
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Make changes as per instructions in the comments."
                }
            ]
            },
            {
            "type": "heading",
            "level": 5,
            "children": [
                {
                "type": "text",
                "value": "Step 2: Changes to your HTML code"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Add the following line under the 'head' tag of your HTML code. The 'src' value of the 'script' tag below must match the relative path of the script you have copied above in step 1."
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "codeBlock",
                "value": "<script src='static/contact-widget-form.js'></script>",
                "language": ""
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "This is it, you are done. You can now open your webpage and see the contact form in action."
                }
            ]
            },
            {
                "type": "paragraph",
                "children": [
                    {
                    "type": "text",
                    "value": "You can find a reference implementation of the widget on a static HTML page at our  " 
                    },
                    {
                    "type": "link",
                    "text": "Github repository",
                    "url": "https://github.com/turbosteed/contact-form-reference-implementation.git"
                    },
                    {
                    "type": "text",
                    "value": "."
                    }
                ]
                },
            {
            "type": "heading",
            "level": 4,
            "children": [
                {
                "type": "text",
                "value": "Viewing form submissions"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "To view the form submissions, please login to your TurboSteed dashboard and visit the "
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Contact Forms section to view all the form submissions."
                }
            ]
            },
            {
            "type": "heading",
            "level": 4,
            "children": [
                {
                "type": "text",
                "value": "Built-In Benefits"
                }
            ]
            },
            {
            "type": "orderedList",
            "children": [
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Enhanced Security: Protect sensitive form data with secure API tokens and encryption."
                    }
                ]
                },
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Easy Management: Access a clean, intuitive dashboard to track form submissions."
                    }
                ]
                },
                {
                "type": "listItem",
                "children": [
                    {
                    "type": "text",
                    "value": "Affordable Pricing: Keep costs low while enjoying enterprise-grade performance."
                    }
                ]
                }
            ]
            },
            {
            "type": "heading",
            "level": 4,
            "children": [
                {
                "type": "text",
                "value": "Get Started Today"
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Whether you’re a developer looking for complete control or a website owner seeking simplicity, Turbosteed’s Contact Form API is your go-to solution. Sign up today and experience the easiest way to add a contact form to your website."
                }
            ]
            },
            {
            "type": "paragraph",
            "children": [
                {
                "type": "text",
                "value": "Register at "
                },
                {
                "type": "link",
                "text": "Turbosteed",
                "url": "https://dashboard.turbosteed.com"
                },
                {
                "type": "text",
                "value": " to learn more and start your journey to hassle-free communication!"
                }
            ]
            }
        ]
        }
    },
    "wix-vs-wordpress": {

        "blogSeo": {
            "mainSeo": {
                "title": "Wix vs. WordPress for SEO: Which Platform Should You Choose?",
                "description": "Don't choose wrong! Our definitive comparison breaks down Wix vs. WordPress for SEO, control, speed, and long-term scalability. Read before you build!",
                "canonicalUrl": "https://turbosteed.com/blogs/wix-vs-wordpress",
                "keywords": "Wix vs WordPress, Wix SEO, WordPress SEO, website builder comparison, WordPress flexibility, Wix ease of use",
                "ogType": "article",
                "ogTitle": "Wix vs. WordPress: The Ultimate Showdown",
                "ogDescription": "Expert breakdown of the pros and cons of Wix vs. WordPress for technical SEO, control, and content management. Find the perfect fit for your site.",
                "ogImage": "https://turbosteed.com/images/social/wix-vs-wordpress.jpg",
                "twitterCard": "summary_large_image",
                "robots": "index, follow",
            },
            "schemaMarkup": {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "Wix vs. WordPress: Which Platform Should You Choose?",
                "image": [
                    "https://turbosteed.com/images/social/wix-vs-wordpress.jpg"
                ],
                "datePublished": "2025-12-10T14:00:00+05:30", // Use the actual publication date/time
                "dateModified": "2025-12-10T14:00:00+05:30", // Use the actual last modification date/time
                "author": {
                    "@type": "Person",
                    "name": "Vivek Joshi" // Use the actual author's name
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "TurboSteed",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://turbosteed.com/turbo-navbar-logo.png"
                    }
                },
                "url": "https://turbosteed.com",
                "name": "TurboSteed Hosting"
            }
        },

        "blogHeader": {
            "blogTitle": "Wix vs Wordpress",
            "blogSubTitle": "Trying to decide between Wix and WordPress platforms (like GoDaddy, Hostinger, Bluehost, and others)? This detailed comparison covers features, customization, speed, pricing, SEO, and security—and introduces TurboSteed as a simpler, faster alternative for static websites.",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Dec 2025",
            "blogCategory": "Choices",
            "blogType": "innerHTML"
        },
        "blogBody": wixVsWordpresss,
        "blogMd": true,
        "blogMdFile": "wix_vs_wordpress.md"
    },

    "turbosteed-for-ai-agents": {
        "blogSeo": {
            "mainSeo": {
                "title": "TurboSteed for AI Agents: Why Agent-Operable Hosting Matters",
                "description": "How AI coding agents like Claude Code are changing web development. Learn about MCP integration, agent-operable hosting, and why TurboSteed is built for this new reality.",
                "canonicalUrl": "https://turbosteed.com/blogs/turbosteed-for-ai-agents",
                "keywords": "AI agents, Claude Code, MCP, agent-operable hosting, AI web development, AI site builder",
                "ogType": "article",
                "ogTitle": "TurboSteed for AI Agents: Agent-Operable Hosting",
                "ogDescription": "The hosting platform built for AI coding agents. Deploy, manage content, and automate workflows with Claude Code and MCP.",
                "twitterCard": "summary_large_image",
                "robots": "index, follow"
            },
            "schemaMarkup": {
                "@context": "https://schema.org",
                "@type": "BlogPosting",
                "headline": "TurboSteed for AI Agents: Why Agent-Operable Hosting Matters",
                "datePublished": "2026-09-10T10:00:00+05:30",
                "dateModified": "2026-09-10T10:00:00+05:30",
                "author": {
                    "@type": "Person",
                    "name": "Vivek Joshi"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "TurboSteed",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://turbosteed.com/turbo-navbar-logo.png"
                    }
                },
                "url": "https://turbosteed.com/blogs/turbosteed-for-ai-agents",
                "name": "TurboSteed Hosting"
            }
        },
        "blogHeader": {
            "blogTitle": "TurboSteed for AI Agents",
            "blogSubTitle": "How AI coding agents like Claude Code are changing web development and why TurboSteed is built for this new reality",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Sep 2026",
            "blogCategory": "Guide",
            "blogType": "innerHTML"
        },
        "blogMd": true,
        "blogMdFile": "turbosteed-for-ai-agents.md"
    }
}

          
      
    

    /*
    "contact-forms" : {
        "blogHeader": {
            "blogTitle": "Quick Contact Forms",
            "blogSubTitle": "Use Contact Forms widget or API to engage with your users",
            "blogWriter": "Vivek Joshi",
            "blogDate": "Dec 2024",
            "blogCategory": "HowTo",
            "blogType": "innerHTML",
            //"markdownPage": "Contact_form.md"
        },
        "blogBody": `
        <p>
At 
<a href=https://turbosteed.com>
TurboSteed
</a>
, we’re all about simplifying static website hosting while packing in powerful features to supercharge your web presence. One of our most exciting offerings is the Contact Form API, a seamless solution for integrating contact forms into your website with minimal effort. This feature does not require any server or database infrastructure on your part.
</p>
<p>
Let’s dive into how this feature works and why it’s an essential tool for modern web hosting.
</p>
<h4>
Why Contact Forms Are Essential
</h4>
<p>
A contact form is more than just a way for visitors to reach out; it’s a cornerstone of effective communication and lead generation for any website. However, implementing and maintaining a contact form on a static website can be a technical challenge. That’s where our Contact Form API and Pre-built Contact Form Widget come into play, offering simplicity and flexibility for developers and non-technical users alike.
</p>
<p>
With our Contact Form API, you can:
</p>
<ul>
<li>Build custom Contact Form UI with TurboSteed API.</li>
<li>Stay secure with API token-based authentication.</li>
</ul>
<ul>
<li>Monitor and manage submissions effortlessly through TurboSteed dashboard.</li>
</ul>
<p>
With our Contact Form Widget, you can:
</p>
<ul>
<li>Use pre-built Contact Form UI for faster integration and without any development (including all of the above benifits).</li>
<li>Allow your site visitors to submit the contact form using the widget.</li>
</ul>
<p>
Here’s how it works:
</p>
<h4>
1. For Developers: Using the Contact Form API
</h4>
<p>
When you sign up for TurboSteed, you receive a unique Account ID and an API Token. These credentials are specifically built for Contact Form API where your website is publicly exposed. Here’s a quick walkthrough:
</p>
<ul>
<li>Implementation: You can design your own contact form UI and configure it to send form submissions directly to our API.</li>
</ul>
<ul>
<li>Authentication: Use your Account ID and API Token in the headers to authenticate requests, ensuring secure communication.</li>
</ul>
<p>
The API endpoint is:
</p>
<p>
<pre>
https://api-us.turbosteed.com/{accountID}/contactForms
</pre>
</p>
<p>
This API uses a HTTP Basic authentication scheme. Please see the implementation example below:
</p>
<h5>
Example
</h5>
<p>
<pre>
const submitForm = async (formData) =&gt; {
  try {
    const response = await fetch(&#039;https://api-us.turbosteed.com/&#039; + YOUR_ACCOUNT_ID + &#039;/contactForms&#039;, {
      method: &#039;POST&#039;,
      headers: {
        &#039;Content-Type&#039;: &#039;application/json&#039;,
        &#039;X-TSA&#039;: btoa(acct + &#039;:&#039; + YOUR_API_TOKEN)  // This is the header under which the token is sent.
      },
      body: JSON.stringify({
        formData: {
          formName: name,        // The input name from the contact form.
          formEmail: email,      // The input email from the contact form.
          formMessage: message   // The input message from the contact form.
        }
      })
    });

    if (!response.ok) {
      throw new Error(&#039;Failed to submit form&#039;);
    }

    console.log(&#039;Form submitted successfully:&#039;, await response.json());
  } catch (error) {
    console.error(&#039;Error submitting form:&#039;, error);
  }
};
</pre>
</p>
<h4>
2. For Non-Developers: Using the React Widget
</h4>
<p>
Not everyone has the time or expertise to build a custom UI, and that’s okay! Turbosteed offers a React-based widget that can be embedded on your website with just a few lines of code.
</p>
<p>
Why Use the Widget?
</p>
<ul>
<li>Quick Setup: Simply copy and paste the widget code into your HTML.</li>
<li>Quick Integration: The widget comes preconfigured to communicate with the Contact Form API. All you need to do is provide your authentication details.</li>
</ul>
<p>
To integrate the widget, you will have to do the following:
</p>
<h5>
Step 2: Changes to your HTML code
</h5>
<p>
Copy the following code in your static assets folder. (This is the folder where you will typically have your css files, images and so on).
</p>
<p>
<pre>
(function() {

  var script = document.createElement(&#039;script&#039;);
  script.type = &#039;text/javascript&#039;;

  script.addEventListener(&#039;load&#039;, function(event) {

    //
    // OPTION CONFIGURATION:
    // Specify the position of the contact form widget.
    // By default, the widget will be placed in the bottom right corner of the page.
    //
    var widget = document.createElement(&#039;div&#039;);
    widget.style.position = &#039;fixed&#039;;
    widget.style.bottom = &#039;20px&#039;;
    widget.style.right = &#039;20px&#039;;
    widget.style.zIndex = &#039;9999&#039;;
    
    //
    // OPTIONAL STYLING:
    // &#039;contact-form&#039; is the element name under which the widget will be displayed.
    // It has a button to show/hide the contact form. You can configure the text and
    // style of the button here. (This button is similar to the window close button
    // on your computer).
    //
    const buttonColor = &#039;white&#039;;             // The background color of the close button.
    const buttonText = &#039;black&#039;;              // The text color of the close button.
    const widgetButtonText = &#039;Contact Us&#039;;   // This is the name of the button  when
                                             // the widget is no longer visible and
                                             // the user has to click this button to
                                             // open the contact form.

    const widgetCloseText = &#039;x&#039;;             // This represents the close icon &#039;x&#039;.
          
    widget.innerHTML = \`
      &lt;div id=&quot;contact-form&quot;&gt;
        &lt;button id=&quot;widget-button&quot; style=&quot;border: none; border-radius: 2px; color: \${buttonText}; background-color: \${buttonColor}&quot; onClick=&quot;(function(event){
          var widget = getElementById(&#039;contact-form-container&#039;);
          if (widget.style.display == &#039;none&#039;) {
            widget.style.display = &#039;block&#039;;
            event.target.innerHTML = &#039;\${widgetCloseText}&#039;;
          }
          else {
            widget.style.display = &#039;none&#039;;
            event.target.innerHTML = &#039;\${widgetButtonText}&#039;;
          }
        })(event)&quot;&gt;
        \${widgetCloseText}
        &lt;/button&gt;
        &lt;div id=&quot;contact-form-container&quot;&gt;&lt;/div&gt;
      &lt;/div&gt;
    \`;

    document.body.appendChild(widget);

    //
    // ACTION REQUIRED:
    // Configure the styling and API details for your widget.
    // 1. The background color for your widget.  (Optional action).
    // 2. The font color for your widget.        (Optional action).
    // 3. The button color for your widget.      (Optional action).
    // 4. The publicly visible TurboSteed account identifier.  (Mandatory action).
    // 5. The publicly visible TurboSteed API token.           (Mandatory action).
    //
    window.ContactFormWidget.renderWidget(&#039;contact-form-container&#039;, {
        backgroundColor: &#039;#f0f0f2&#039;,
        fontColor: &#039;black&#039;,
        buttonColor: &#039;#1FA868&#039;,
        apiAcct: &#039;xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx&#039;,
        apiToken: &#039;xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx&#039;
    });
  });

  //
  // This is the address of the contact form widget on TurboSteed. Do not
  // change this.
  //
  script.src = &#039;https://turbosteed.com/contact-widget.js&#039;;

  //    
  // The widget in this example will be appended as the last HTML element of the page.  
  //    
  document.head.appendChild(script);
})();
</pre>
</p>
<p>
Make changes as per instructions in the comments.
</p>
<h5>
Step 2: Changes to your HTML code
</h5>
<p>
Add the following line under the 'head' tag of your HTML code. The 'src' value of the
</p>
<p>
'script' tag below must match the relative path of the script you have copied above in
</p>
<p>
step 1.
</p>
<p>
<pre>
&lt;script src=&#039;static/contact-widget-form.js&#039;&gt;&lt;/script&gt;
</pre>
</p>
<p>
This is it, you are done. You can now open your webpage and see the contact form in action.
</p>
<h4>
Viewing form submissions
</h4>
<p>
To view the form submissions, please login to your TurboSteed dashboard and visit the 
</p>
<p>
Contact Forms section to view all the form submissions.
</p>
<h4>
Built-In Benefits
</h4>
<ol>
<li>Enhanced Security: Protect sensitive form data with secure API tokens and encryption.</li>
<li>Easy Management: Access a clean, intuitive dashboard to track and export form submissions.</li>
<li>Affordable Pricing: Keep costs low while enjoying enterprise-grade performance.</li>
</ol>
<h4>
Get Started Today
</h4>
<p>
Whether you’re a developer looking for complete control or a website owner seeking simplicity, Turbosteed’s Contact Form API is your go-to solution. Sign up today and experience the easiest way to add a contact form to your website.
</p>
<p>
Visit 
<a href=https://turbosteed.com>
Turbosteed
</a>
 to learn more and start your journey to hassle-free communication!
</p>

        `
    }
        */


export const BodyStyleOld = {
    "p": "",
    "image": "my-4 p-4",
    "subTitle": "h4",
    "pre": "pre-format"

}

export const BodyStyle = {
    "p": "",
    "image": "my-2 p-1",
    "subTitle": "h4",
    "pre": "pre-format"

}